import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { useAuth } from '../context/AuthContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate('/', { replace: true }); return; }
    const session_id = match[1];
    (async () => {
      try {
        const { data } = await api.post('/auth/google/session', { session_id });
        setUser(data.user);
        const dest = sessionStorage.getItem('post_login_redirect') || '/';
        sessionStorage.removeItem('post_login_redirect');
        window.history.replaceState({}, '', dest);
        navigate(dest, { replace: true, state: { user: data.user } });
      } catch (e) {
        console.error(e);
        navigate('/login', { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="w-10 h-10 mx-auto border-4 border-primary/20 border-t-primary rounded-full animate-spin" />
        <p className="mt-4 text-muted-foreground">Signing you in…</p>
      </div>
    </div>
  );
}
